import FingerprintJS from "@fingerprintjs/fingerprintjs";
import type { RawComponent } from "./types.js";

/** Established maintained baseline library (docs/detection-and-risk.md) — one collector among several, never a single point of failure. */
export async function collectFingerprintJsVisitorId(): Promise<RawComponent> {
  try {
    const agent = await FingerprintJS.load();
    const result = await agent.get();
    return { name: "fingerprintjs_visitor_id", rawValue: result.visitorId };
  } catch {
    return { name: "fingerprintjs_visitor_id", rawValue: null };
  }
}
